import type {
  ConcernLevel,
  ControversyLevel,
  OverallSentiment,
  Sentiment,
} from './types';

export const sentimentColor: Record<OverallSentiment, string> = {
  'Very Positive': '#15803d',
  Positive: '#16a34a',
  Neutral: '#64748b',
  Negative: '#d97706',
  'Very Negative': '#b91c1c',
};

export const sentimentBgTint: Record<OverallSentiment, string> = {
  'Very Positive': '#f0fdf4',
  Positive: '#f0fdf4',
  Neutral: '#f8fafc',
  Negative: '#fffbeb',
  'Very Negative': '#fef2f2',
};

export const controversyColor: Record<ControversyLevel, string> = {
  None: '#16a34a',
  Minor: '#64748b',
  Moderate: '#d97706',
  High: '#dc2626',
  Severe: '#991b1b',
};

export const controversyBg: Record<ControversyLevel, string> = {
  None: '#f0fdf4',
  Minor: '#f8fafc',
  Moderate: '#fffbeb',
  High: '#fef2f2',
  Severe: '#fef2f2',
};

export interface ChipStyle {
  color: string;
  bg: string;
  border: string;
}

export const sentimentChip: Record<Sentiment, ChipStyle> = {
  Positive: { color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0' },
  Neutral: { color: '#64748b', bg: '#f8fafc', border: '#e2e8f0' },
  Negative: { color: '#dc2626', bg: '#fef2f2', border: '#fecaca' },
};

export const concernChip: Record<Exclude<ConcernLevel, 'None'>, ChipStyle> = {
  Low: { color: '#0369a1', bg: '#eff6ff', border: '#bfdbfe' },
  Medium: { color: '#d97706', bg: '#fffbeb', border: '#fde68a' },
  High: { color: '#dc2626', bg: '#fef2f2', border: '#fecaca' },
};

export interface ScoreStyle {
  color: string;
  bg: string;
  border: string;
  label: 'Safe' | 'Moderate' | 'Risky';
}

export function scoreStyle(score: number): ScoreStyle {
  if (score >= 70) {
    return { color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0', label: 'Safe' };
  }
  if (score >= 45) {
    return { color: '#d97706', bg: '#fffbeb', border: '#fde68a', label: 'Moderate' };
  }
  return { color: '#dc2626', bg: '#fef2f2', border: '#fecaca', label: 'Risky' };
}
